/**
 * 外車（同業）接單頁型別（openspec add-external-driver-grab）
 * 對應後端 presentation/lineext/dto。與會員司機的 Task 型別分開，互不影響。
 */

export interface ExtDriver {
  id: string
  trailerNo: string
  driverName: string
  mobile?: string | null
  companyName?: string | null
}

export interface ExtLoginResponse {
  bound: boolean
  accessToken: string
  accessTokenExpiresIn: number
  driver?: ExtDriver | null
}

export interface ExtBindRequest {
  trailerNo: string
  driverName: string
  mobile?: string
  companyName?: string
}

export interface ExtBatchCard {
  /** 批次鍵：放櫃批次號，MY 櫃放櫃則為貨櫃 id */
  batchKey: string
  vesselCode: string
  vesselName?: string | null
  originLocation?: string | null
  originShortName?: string | null
  dischargePort?: string | null
  containerSize?: string | null
  emptyLoaded?: string | null // E 空櫃 / L 重櫃
  releaseRemark?: string | null
  total: number
  remaining: number
  accepted: number
  completed: number
}

export interface ExtMission {
  missionId: string
  batchKey: string
  vesselCode: string
  vesselName?: string | null
  originLocation?: string | null
  originShortName?: string | null
  destinationLocation?: string | null
  destShortName?: string | null
  containerSize?: string | null
  emptyLoaded?: string | null
  status: string // 13 已接單 / 20 執行中 / 30 已完成
  containerNo?: string | null
  seq?: number | null
  acceptedTime?: string | null
  finishTime?: string | null
}

/** CLOSED：整批已全數完成（2026-09-29 前這種情況回「連結已失效」） */
export type ExtBlockReason = 'HAS_UNFINISHED' | 'FULL' | 'CLOSED' | null

export interface ExtBatchResponse {
  card: ExtBatchCard
  status: 'OPEN' | 'FULL' | 'CLOSED'
  mine: ExtMission[]
  unfinished: ExtMission[]
  canGrab: boolean
  blockReason: ExtBlockReason
}

export interface ExtGrabResponse {
  mission: ExtMission | null
  card: ExtBatchCard
}

export const EMPTY_LOADED_LABEL: Record<string, string> = { E: '空櫃', L: '重櫃' }
export const MISSION_STATUS_LABEL: Record<string, string> = { '13': '已接單', '20': '執行中', '30': '已完成' }
